import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { OAuthData } from '../recoil-states/user-state/user-OAuth';
import NotSiba from '../assets/mypage_profil.png';
import Loading from './Loading';
import editImage from '../assets/edit_image.png';
import DefaultImg from '../assets/default_profile.png';
import { decryptedData, encryptedData } from '../function/functions';

const EditModal = ({ nickName, setNickName, setOpenEditModal }) => {
	const [userData, setUserData] = useRecoilState(OAuthData);
	const fileRef = useRef();
	const [addImage, setAddImage] = useState([]);
	const editNickName = useState(false);
	const [imageUrl, setImageUrl] = useState('');
	const [loading, setLoading] = useState(false);
	const formData = new FormData();
	const [changeNickName, setChangeNickName] = useState(
		userData?.profile_nick_name ? userData?.profile_nick_name : 'nickName'
	);
	const [userChangeData, setUserChangeData] = useRecoilState(OAuthData);
	const [editIcon, setEditIcon] = useState(false);
	const [onEdit, setOnEdit] = useState(false);
	const inputRef = useRef();

	const openFile = () => {
		fileRef.current.click();
	};

	const callApi = () => {
		setLoading(true);
		formData.append('file', addImage[0]);
		try {
			axios
				.post(`${process.env.REACT_APP_BACKEND_API}/files`, formData)
				.then(res => {
					setImageUrl(res.data.data.id);
					setLoading(false);
				})
				.catch(err => {
					setLoading(false);
					alert('이미지 용량이 20mb를 초과했습니다.');
				});
		} catch {
			setUserChangeData({
				email: userData?.email,
				email_provider: userData?.email_provider,
				index: userData?.index,
				link_State: userData?.link_State,
				profile_image_url: userData?.profile_image_url,
				profile_nick_name:
					changeNickName !== userData?.profile_nick_name
						? changeNickName
						: userData?.profile_nick_name,
				wallet_address: userData?.wallet_address,
				wallet_provider: userData?.wallet_provider,
				sub_wallet_address: userData?.sub_wallet_address,
			});
			setLoading(false);
		}
	};

	const changeFile = e => {
		setAddImage(e.target.files);
	};

	useEffect(() => {
		if (addImage.length > 0) {
			callApi();
		}
	}, [addImage]);

	const onSubmit = async () => {
		setLoading(true);
		try {
			axios
				.post(
					`${process.env.REACT_APP_BACKEND_API}/kct/profile_update`,
					{
						user_list_index: userData.index,
						profile_image_url:
							imageUrl.length > 0
								? `${process.env.REACT_APP_BACKEND_API}/assets/${imageUrl}`
								: userData.profile_image_url,
						profile_nick_name: changeNickName,
					}
				)
				.then(res => {
					setUserChangeData({
						email: userData?.email,
						email_provider: userData?.email_provider,
						index: userData?.index,
						link_State: userData?.link_State,
						profile_image_url:
							imageUrl.length > 0
								? `${process.env.REACT_APP_BACKEND_API}/assets/${imageUrl}`
								: userData?.profile_image_url,
						profile_nick_name:
							changeNickName !== userData.profile_nick_name
								? changeNickName
								: userData?.profile_nick_name,
						wallet_address: userData?.wallet_address,
						wallet_provider: userData?.wallet_provider,
						sub_wallet_address: userData?.sub_wallet_address,
					});
					sessionStorage.removeItem('userData');
					sessionStorage.setItem(
						'userData',
						encryptedData(userChangeData)
					);
					setLoading(false);
					setOpenEditModal(false);
				});
		} catch (err) {
			alert('에러발생');
			setLoading(false);
		}
	};

	useEffect(() => {
		if (onEdit) {
			inputRef.current.focus();
		}
	}, [onEdit]);

	useEffect(() => {
		axios
			.post(`${process.env.REACT_APP_BACKEND_API}/kct/email_login`, {
				email: userData?.email,
				email_provider: userData?.email_provider,
			})
			.then(res => {
				setNickName(res.data.profile_nick_name);
			});
	}, []);

	const onCloseModal = e => {
		if (e.target.id === 'edit_modal') {
			setOpenEditModal(false);
		}
	};

	return (
		<div className='edit_modal' id='edit_modal' onClick={onCloseModal}>
			{loading ? <Loading /> : null}
			<div className='edit_modal_container'>
				<button
					onClick={() => {
						setOpenEditModal(false);
					}}
				>
					X
				</button>
				<h1>PROFILE SETTING</h1>
				<div
					onClick={openFile}
					className='edit_profile_image'
					onMouseOver={() => setEditIcon(true)}
					onMouseLeave={() => setEditIcon(false)}
				>
					{userData?.profile_image_url !== null &&
					userData?.profile_image_url ? (
						<>
							<img
								src={
									addImage.length > 0 || imageUrl.length > 0
										? `${process.env.REACT_APP_BACKEND_API}/assets/${imageUrl}`
										: userData?.profile_image_url
								}
							/>
							<input
								type='file'
								accept='.jpg, .png'
								ref={fileRef}
								onChange={changeFile}
								style={{ display: 'none' }}
							/>
						</>
					) : (
						<>
							<img
								src={
									addImage.length > 0 || imageUrl.length > 0
										? `${process.env.REACT_APP_BACKEND_API}/assets/${imageUrl}`
										: DefaultImg
								}
							/>
							<input
								type='file'
								accept='.jpg, .png'
								ref={fileRef}
								onChange={changeFile}
								style={{ display: 'none' }}
							/>
						</>
					)}
					<div
						className='edit_icon'
						style={editIcon ? { opacity: 1 } : { opacity: 0 }}
					>
						<img src={editImage} />
					</div>
				</div>
				<div className='username_box'>
					<p>UserName</p>
				</div>
				<div
					className='edit_nickname'
					style={{
						border: onEdit ? '2px solid #20CE69' : '2px solid #fff',
					}}
				>
					{onEdit ? (
						<input
							ref={inputRef}
							type={'text'}
							value={changeNickName}
							onChange={e => setChangeNickName(e.target.value)}
							disabled={editNickName ? undefined : true}
						/>
					) : (
						<p>{changeNickName}</p>
					)}
					<img src={editImage} onClick={() => setOnEdit(true)} />
				</div>
				<div className='edit_success_btn'>
					<button onClick={onSubmit}>Edit</button>
				</div>
			</div>
		</div>
	);
};

export default EditModal;
